export default __webpack_public_path__ + "static/media/Menu_header_mobileview.eac07f32.svg";